import React from 'react'
import BaseLogo from './base-logo.component'

export const Top4000Logo = ({ fontSize }) => (
	<BaseLogo fontSize={fontSize}>
		<div className="name">top</div>
		<div className="points dark-orange">4000</div>
	</BaseLogo>
)
